import React from 'react'
import './styles.scss'

import BetaMark from 'components/common/BetaMark'

/**
 * Container Page
 * @param {object} props
 * @param {React.Component} props.children
 * @param {string} {props.className}
 * @param {boolean} {props.displayBeta}
 * @param {string|React.Component} {props.title}
 *
 * @returns {React.Component}
 */
const ContainerPage = (props) => {
  const { title, children, className = '', displayBeta = false } = props

  return (
    <div className={`nx-container-page ${className}`}>
      <div className='nx-container-page__title-wrapper'>
        {
          title
            ? (
              <div className='nx-container-page__title'>
                {title}
              </div>
            )
            : null
        }
        {
          displayBeta
            ? <BetaMark />
            : null
        }
      </div>

      {children}
    </div>
  )
}

export default ContainerPage
